import { memo } from 'react'
import GenericCarousel from 'src/components/restructure/product/sections/ProductInformationSection/ProductDescriptionCarousel/Carousel/GenericCarousel'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

type MiniPdpBenefitsCarouselProps = {
  content: string
}

const MiniPdpBenefitsCarousel = ({ content }: MiniPdpBenefitsCarouselProps) => {
  const { pageData } = useGlobalContext()
  const standardObject = getStandardObject(pageData)

  const handleNavigate = () => {
    dispatchAmplitudeEvent({
      eventName: 'Click Icons',
      eventData: {
        ...standardObject,
        'click name': 'Ver características',
      },
    })
  }

  if (!content) {
    return null
  }

  return (
    <section className="max-w-[99vw] mb-6 -ml-5 md:-ml-1 md:max-w-full -mr-8">
      <div className="w-full overflow-hidden [&_.benefit-content]:contents [&_.benefit-description]:col-span-2 [&_.benefit-description]:mt-1 [&_.benefit-description]:text-xs [&_.benefit-description]:leading-5 [&_.benefit-description]:font-medium [&_.benefit-description]:text-secondary [&_.benefit-image]:h-4 [&_.benefit-image]:w-4 [&_.benefit-item]:grid [&_.benefit-item]:h-full [&_.benefit-item]:w-[272px] [&_.benefit-item]:grid-cols-[auto_1fr] [&_.benefit-item]:items-start [&_.benefit-item]:gap-x-3 [&_.benefit-item]:gap-y-1 [&_.benefit-item]:bg-[#F7F8F9] [&_.benefit-item]:px-4 [&_.benefit-item]:py-5 [&_.benefit-item]:restructure-tablet:w-[292px] [&_.benefit-title]:text-base [&_.benefit-title]:leading-6 [&_.benefit-title]:font-semibold [&_.benefit-title]:text-restructure-primary">
        <GenericCarousel title="Características" onNavigate={handleNavigate}>
          <article
            data-testid="miniPdpProductBenefits"
            className="text-neutral06 text-sm font-medium mt-6"
          >
            <div
              className="flex gap-3"
              suppressHydrationWarning
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(content),
              }}
            />
          </article>
        </GenericCarousel>
      </div>
    </section>
  )
}

export default memo(MiniPdpBenefitsCarousel)
